import React from "react"
import { PageContainerWrapper } from "../App"
import { Box, IconButton, Link, Typography } from "@mui/material"
import PhoneForwardedIcon from "@mui/icons-material/PhoneForwarded"
import homeImg from "../assets/img/img1.jpg"

const HomePage = () => {
	return (
		<PageContainerWrapper>
			<Typography variant="h4" paragraph>
				ИНЖЕНЕРНО-ГЕОДЕЗИЧЕСКИЕ ИЗЫСКАНИЯ
			</Typography>
			<Typography paragraph>
				Предприятие «Геоземплан» имеет более 20-лет опыта выполнения данных
				работ для объектов гражданского и промышленного строительства, работ по
				землеустроению.
			</Typography>
			<Typography>
				Основными видами оказываемых услуг в настоящее время являются:
			</Typography>
			<Typography>
				- работы в составе инженерно-геодезических изысканий;
			</Typography>
			<Typography>- геодезические работы в строительстве ;</Typography>
			<Typography>
				- исполнительные съемки подземных инженерных сетей ;
			</Typography>
			<Typography paragraph>
				- установление (восстановление) границ земельных участков .
			</Typography>
			<Typography paragraph>
				Инженерно-геодезические мероприятия являются составной частью процесса
				строительного проектирования.
			</Typography>
			<Typography paragraph>
				В собственности предприятия находятся производственные помещения,
				электронные тахеометры Leica, нивелиры, оборудование, два комплекта
				двухчастотных GPS-приемников Topcon GB-1000, трассоискатель
				Radiodetection, плоттер, набор компьютерной техники с соответствующим
				программным обеспечением.
			</Typography>
			<Typography paragraph>
				Предприятие имеет аттестат соответствия третьей категории и выполняет
				работы в составе геодезических изысканий.
			</Typography>
			<Typography paragraph>
				Предприятие применяет упрощенную систему налогообложения без уплаты НДС
				с уплатой налога в размере 5% от валовой выручки.
			</Typography>
			<Typography paragraph>
				По всем интересующим вас вопросам мы готовы предоставить полную
				информацию, а также рассмотреть и обсудить ваши предложения.
			</Typography>
			<Typography>С уважением,</Typography>
			<Typography paragraph>
				директор УП «Геоземплан» – Онищук Анатолий Николаевич
			</Typography>

			<Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
				<Link type="phone" href="tel:80173480978" underline="hover" mb={0.5}>
					Тел. (017) 348-09-78
				</Link>
				<Link type="phone" href="tel:80173480978" underline="hover" mb={0.5}>
					<IconButton color="warning">
						<PhoneForwardedIcon />
					</IconButton>
				</Link>
			</Box>

			<Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
				<Link type="phone" href="tel:+375296113213" underline="hover" mb={0.5}>
					A1: 8029-6-113-213
				</Link>
				<Link type="phone" href="tel:+375296113213" underline="none" mb={0.5}>
					<IconButton color="success">
						<PhoneForwardedIcon />
					</IconButton>
				</Link>
			</Box>

			<Typography paragraph>email: geozemplan@tut.by</Typography>
			<Box sx={{ width: "100%", overflow: "hidden" }}>
				<img src={homeImg} alt="man svg" style={{ maxWidth: "100%" }} />
			</Box>

			<Typography paragraph>
				Для того, чтобы связаться с нами и заказать землеустроительные и
				инженерно-геодезические услуги, достаточно перейти в раздел контакты и
				позвонить по указанному телефону. Услугами предприятия постоянно
				пользуются УКС администрации Первомайского района г. Минска, филиал
				«Минские тепловые сети» РУП «Минскэнерго», филиал «Минские кабельные
				сети» РУП «Минскэнерго», НИиПИ «Белэнергосетьпроект», ОАО
				«Минскгражданпроект», Минская дистанция гражданских сооружений РУП
				«Минское отделение БелЖД» и др.и довольны оказанными услугами.
			</Typography>
		</PageContainerWrapper>
	)
}

export default HomePage
